module.exports = {"sorry":"Siamo spiacenti, si è verificato un errore.","tryagain":"Prova a ricaricare"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/PageError/localization/it-IT/strings.json
// module id = 1178
// module chunks = 0